// src/data/exercises/L4_07.js

// 1. Import trực tiếp các file ảnh từ thư mục assets
// TODO: Thay đổi tên file cho đúng với file ảnh của bạn
import GiaiThichDung from '../../assets/images/L4_07d.png';
import GoiYCoBan from '../../assets/images/L4_07s.png';
import GoiYChiTiet from '../../assets/images/L4_07d.png';

const accountOptions = [
  '当座預金', '資本金', '損益', '繰越利益剰余金', '普通預金'];

export const L4_07 = {
  title: '簿記　3級（第212-7回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
   parts: [
    { "type": "ruby", "text": "株式会社岡山商店", "ruby": "かぶしきがいしゃおかやましょうてん" },
    { "type": "text", "value": "の" },
    { "type": "ruby", "text": "当期決算", "ruby": "とうきけっさん" },
    { "type": "text", "value": "において、" },
    { "type": "ruby", "text": "当期純利益", "ruby": "とうきじゅんりえき" },
    { "type": "text", "value": "が￥4,300,000と" },
    { "type": "ruby", "text": "算定", "ruby": "さんてい" },
    { "type": "text", "value": "された。" }
],
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '損益', debitAmount: 4300000, creditAccount: '繰越利益剰余金', creditAmount: 4300000},
      ],

      // 2. Gán trực tiếp biến đã import vào
      explanation_correct: GiaiThichDung,

      hints: {
        account: [
          // Gợi ý lần 1, 2
          GoiYCoBan,
          // Gợi ý lần 3 trở đi
          GoiYChiTiet,
        ],
      },
    },
  ],
};